<template>
	<app-page>
		<app-heading :title="isNew ? 'New Role' : role.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'api-roles' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="role.name"
					required
					:errors="errors.name"
				/>
				<input-checkbox
					label="Is administrator"
					v-model="isAdmin"
				/>
				<div
					v-for="permission in permissions"
					:key="permission.code"
					class="mb-4"
					v-show="!isAdmin"
				>
					<app-divider class="mb-4" />
					<h3>{{permission.name}}</h3>
					<div>{{permission.description}}</div>
					<input-select
						label="Permissions"
						:items="actions"
						multiple
						v-model="role.permissions[permission.code]"
					/>
				</div>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
import { mapValues, reduce } from 'lodash'

export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			// @todo - Add permissions graph node and replace
			this.permissions = await this.$ravello.request().to('permissions').get()
			if (this.id !== 'new') {
				const role = await this.$ravello.request()
					.to('roles')
					.to(this.id)
					.get()
				this.role = {
					name: role.name,
					permissions: mapValues(role.permissions, (permission) => {
						if (permission === true) {
							return ['get', 'put', 'post', 'delete']
						}

						return reduce(permission, (acc, value, action) => {
							if (value) {
								return [...acc, action]
							}
							return acc
						}, [])
					}),
				}
				this.isAdmin = typeof this.role.permissions['*'] !== 'undefined'
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			role: {
				name: '',
				permissions: {},
			},
			isAdmin: false,
			permissions: [],
			errors: {},
		}
	},
	computed: {
		id() {
			return this.$route.params.role
		},
		isNew() {
			return this.id === 'new'
		},
		actions() {
			return [
				{
					text: 'Read',
					value: 'get',
				}, {
					text: 'Create',
					value: 'post',
				}, {
					text: 'Update',
					value: 'put',
				}, {
					text: 'Delete',
					value: 'delete',
				},
			]
		},
	},
	methods: {
		async onSubmit() {
			const permissions = this.isAdmin
				? { '*': true }
				: reduce(this.role.permissions, (acc, permission, name) => {
					if (name === '*') {
						return acc
					}
					if (permission.length === 4) {
						return { ...acc, [name]: true }
					}
					if (permission.length > 0) {
						return {
							...acc,
							[name]: permission.reduce(
								(actionAcc, action) => ({ ...actionAcc, [action]: true }),
								{},
							),
						}
					}
					return acc
				}, {})

			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request().to('roles').create({
						name: this.role.name,
						permissions,
					})
				} else {
					await this.$ravello.request().to('roles').to(this.id).update({
						name: this.role.name,
						permissions,
					})
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Role successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'api-roles' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
